import React, {useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MainService from "../../Common/MainService";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Box from "@material-ui/core/Box";
import { NotificationManager } from "react-notifications";
import Button from "@material-ui/core/Button";
import "./ViewProductionTeamsComponent.css";
import { withGoogleMap, GoogleMap, Marker, Polyline,InfoWindow } from 'react-google-maps';
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import SearchBar from "material-ui-search-bar";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ListIcon from "@material-ui/icons/List";
import GridIcon from "@material-ui/icons/GridOnOutlined";
import MapIcon from "@material-ui/icons/MapRounded";
import sha256 from "sha256";
import CircularProgress from "@material-ui/core/CircularProgress";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(5),
    right: theme.spacing(5),
    zIndex: 10,
    color: "#fff",
  },
}));

export default function ViewProductionTeamsComponent() {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isLoading, setIsLoading] = useState(false);
  const [setListOpe, getListOpe] = useState(false);
  const [setGridOpe, getGridOpe] = useState(true);
  const [setMapOpe, getMapOpe] = useState(false);
  const [setViewSites, getViewSites] = useState(false);
  const [setGridSites, getGridSites] = useState(false);
  const [setMapSites, getMapSites] = useState(false);
  const [setUsers, getUsers] = useState([]);
  const { user } = MainService.getLocalData();
  const { username, parentId } = user;
  const [setResources, getResources] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [setmarker_position, getmarker_position] = useState({ lat: 0 , lng: 0});
  /*Creator Production Teams */
  const [consumerUserDialog, setConsumerUserDialog] = useState(false);
  const [usernameValue, setUsernameValue] = useState("");
  const [firstNameValue, setFirstNameValue] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const [domainNameValue, setDomainNameValue] = useState("");
  const [userTypeValue, setUserTypeValue] = useState("Production-Team");
  const [email, setEmail] = useState("");
  const [phoneNumerValue, setPhoneNumerValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [cityNameValue, setCityNameValue] = useState("");
  const [stateNameValue, setStateNameValue] = useState("");
  const [nomineeValue, setNomineeValue] = useState("");
  const [pancardValue, setPancardValue] = useState("");
  const [longitudeValue, setLongitudeValue] = useState("");
  const [latitudeValue, setLatitudeValue] = useState("");
  const [messageValue, setMessageValue] = useState("");
   /*End Creator Production Teams */
   /*Delete Production Teams */
   const [consumerUserDeleteDialog, setConsumerUserDeleteDialog] = useState(false);
   const [selectedConsumerUserName, setSelectedConsumerUserName] = useState("");
   const [selectedConsumerUserId, setSelectedConsumerUserId] = useState("");
   /*End Of Delete Production Teams */
   /*Production Teams Password Reset*/
   const [consumerUserResetPasswordDialog, setconsumerUserResetPasswordDialog] = useState(false);
   const [newPasswordValue, setNewPasswordValue] = useState("");
   const [passwordConfirmationValue, setPasswordConfirmationValue] = useState("");
   /*End Of Production Teams Password Reset*/
   /*Production Teams Update*/
  const [consumerUserUpdateDialog, setConsumerUserUpdateDialog] = useState(false);
  const [consumerUserUserId, setConsumerUserUserId] = useState("");
  const [consumerUserUserName, setConsumerUserUserName] = useState("");
  const [consumerUserFirstName, setConsumerUserFirstName] = useState("");
  const [consumerUserLastName, setConsumerUserLastName] = useState("");
  const [consumerUserEmail, setConsumerUserEmail] = useState("");
  const [consumerUserPhone, setConsumerUserPhone] = useState("");
  const [consumerUserAddress, setConsumerUserAddress] = useState("");
  const [consumerUserCity, setConsumerUserCity] = useState("");
  const [consumerUserState, setConsumerUserState] = useState("");
  const [consumerUserNominee, setConsumerUserNominee] = useState("");
  const [consumerUserPancard, setConsumerUserPancard] = useState("");
  const [consumerUserLongitude, setConsumerUserLongitude] = useState("");
  const [consumerUserLatitude, setConsumerUserLatitude] = useState("");
  const [consumerUserMessage, setConsumerUserMessage] = useState("");
  const [consumerUserUserType, setConsumerUserUserType] = useState("");
  const [consumerUserUserDomainName, setConsumerUserUserDomainName] = useState("");
   /*End Of Production Teams Update*/
   /*Update Node Status */
   const [consumerUserUpdateNodeStatusDialog,setConsumerUserUpdateNodeStatusDialog] = useState(false);
   const [selectedNodeNameValue, setSelectedNodeNameValue] = useState("");
   const [nodeStatusValue, setNodeStatusValue] = useState("");
   /*End Of Update Node Status */
   /*Node Info */
   const [consumerUserViewNodeInfoDialog, setConsumerUserViewNodeInfoDialog] = useState(false);
   const [nodeUserName, setNodeUserName] = useState("");
   const [nodeUserNodeId, setNodeUserNodeId] = useState("");
   const [nodeUserAccountType, setNodeUserAccountType] = useState("");
   const [nodeUserUserType, setNodeUserUserType] = useState("");
   const [nodeUserAssetType, setNodeUserAssetType] = useState("");
   const [nodeUserNumberOfAssets, setNodeUserNumberOfAssets] = useState("");
   const [nodeUserAreaSize, setNodeUserAreaSize] = useState("");
   const [nodeUserGrazingType, setNodeUserGrazingType] = useState("");
   const [nodeUserFeedType, setNodeUserFeedType] = useState("");
   const [nodeUserNumberOfKids, setNodeUserNumberOfKids] = useState("");
   const [nodeUserMaleGenderNumber, setNodeUserMaleGenderNumber] = useState("");
   const [nodeUserFemaleGenderNumber, setNodeUserFemaleGenderNumber] = useState("");
   const [nodeUserOverallAge, setNodeUserOverallAge] = useState("");
   const [nodeUserBreed, setNodeUserBreed] = useState("");
   const [nodeUserFarmingExperience, setNodeUserFarmingExperience] = useState("");
   const [nodeUserNodeStatus, setNodeUserNodeStatus] = useState("");
   const [nodeUserContentUrl, setNodeUserContentUrl] = useState("");
   const [nodeUserNodeType, setNodeUserNodeType] = useState("");
   const [nodeUserAssetverticalId, setNodeUserAssetverticalId] = useState(""); 
   const [nodeUserAssetverticalFriendlyName,setNodeUserAssetverticalFriendlyName] = useState("");
   const [nodeUserFirstName, setNodeUserFirstName] = useState("");
   const [nodeUserLastName, setNodeUserLastName] = useState("");
   const [nodeUserEmail, setNodeUserEmail] = useState("");
   const [nodeUserPhone, setNodeUserPhone] = useState("");
   const [nodeUserAddress, setNodeUserAddress] = useState("");
   const [nodeUserCity, setNodeUserCity] = useState("");
   const [nodeUserState, setNodeUserState] = useState("");
   const [nodeUserDistrict, setNodeUserDistrict] = useState("");
   const [nodeUserPincode, setNodeUserPincode] = useState("");
   const [nodeUserLatitude, setNodeUserLatitude] = useState("");
   const [nodeUserLongitude, setNodeUserLongitude] = useState("");
   const [nodeUserTimestamp, setNodeUserTimestamp] = useState("");
   /*End Of Node Info */
   const [getType,setType] = useState("");
   const [searched, setSearched] = useState("");
   const [setFilterUsers, getFilterUsers] = useState([]);
   const [farmgridsearched, setFarmGridSearched] = useState("");

   /*List Filter */
  const requestSearch = (searchedVal) => {
    const filteredRows = setFilterUsers.filter((row) => {
      return row.username.toLowerCase().includes(searchedVal.toLowerCase());
    });
    getUsers(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  /*Grid Filter */
  const requestFarmGridSearch = (searchedVal) => {
    const filteredRows = setFilterUsers.filter((row) => {
      return row.username.toLowerCase().includes(searchedVal.toLowerCase());
    });
    getUsers(filteredRows);
  };

  const cancelFarmGridSearch = () => {
    setFarmGridSearched("");
    requestFarmGridSearch(farmgridsearched);
  };

  useEffect(()=>{
    listOfTeams();
  },[getUsers]);

  useEffect(()=>{
    return  navigator?.geolocation.getCurrentPosition(({coords: {latitude: lat, longitude: lng}}) => {
       const pos = {lat, lng} 
       getmarker_position(pos);
     })
   },[]);

  /* Pagination */

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* End Pagination */
   
  const listOfTeams = (Type) =>{
    setType(Type);
    if(Type === "List"){
      getListOpe(true);
      getGridOpe(false);
      getMapOpe(false);

      getViewSites(false);
      getGridSites(false);
      getMapSites(false);
    } else if(Type === "Grid"){
      getListOpe(false);
      getGridOpe(true);
      getMapOpe(false);

      getViewSites(false);
      getGridSites(false);
      getMapSites(false);
    } else if(Type === "Map"){
      getListOpe(false);
      getGridOpe(false);
      getMapOpe(true);

      getViewSites(false);
      getGridSites(false);
      getMapSites(false);
    }
    
    MainService.viewListOfProductionTeams(username)
    .then((res)=>{
      getUsers(res.users);
      getFilterUsers(res.users);
    })
    .catch((err)=>{
      return NotificationManager.error(err);
    })
  };

  const roleNameOfTeam = (name,Type) =>{
    MainService.getTeamRole(name)
    .then((res)=>{
      getTeamRoles(res.role,Type);
    })
    .catch((err)=>{
      return NotificationManager.error(err);
    })
  };

  const getTeamRoles = (role,Type) =>{

    if(Type === "List"){
      getListOpe(false);
      getGridOpe(false);
      getMapOpe(false);

      getViewSites(true);
      getGridSites(false);
      getMapSites(false);
    } else if(Type === "Grid"){
      getListOpe(false);
      getGridOpe(false);
      getMapOpe(false);

      getViewSites(false);
      getGridSites(true);
      getMapSites(false);
    } else if(Type === "Map"){
      getListOpe(false);
      getGridOpe(false);
      getMapOpe(false);

      getViewSites(false);
      getGridSites(false);
      getMapSites(true);
    }

    MainService.getTeamRoleResourceId(role,username)
    .then((res)=>{
      if(res.length > 1){
        getResources(res);
      } else {
        getResources([res]);
      } 
    })
    .catch((err)=>{
      return NotificationManager.error("err");
    });
  };

  /*************** Production Teams Map *************/
  const TeamsGoogleMap = withGoogleMap(() => {
    
    return (
      <GoogleMap
          key={setUsers.index}
          defaultZoom = { 13 }
          defaultCenter={setmarker_position}
          center={setmarker_position}
      >
          {setUsers.map((value, index) => {
          return (
           (value) ? <Marker 
                      key ={index} 
                      position={{lat: parseFloat(value.latitude), lng: parseFloat(value.longitude)}}
                      >
                        <InfoWindow 
                        options={{disableAutoPan: true}} 
                        >
                          <button type="button" onClick={()=>{roleNameOfTeam(value.username,"Map")}}>
                            <div>{value.username}</div>
                          </button>
                        </InfoWindow>
                    </Marker> : ''
          )
          })}
        
        {/* <Polyline path={props.polyPath} defaultZoom={2} editable={false} /> */}
      </GoogleMap>
    );
  });

  const SitesGoogleMap = withGoogleMap(() => {
    
    return (
      <GoogleMap
          key={setResources.index}
          defaultZoom = { 13 }
          defaultCenter={setmarker_position}
          center={setmarker_position}
      >
          {setResources.map((value, index) => {
          return (
           (value) ? <Marker 
                      key ={index} 
                      position={{lat: parseFloat(value.latitude), lng: parseFloat(value.longitude)}}
                      >
                        <InfoWindow 
                        options={{disableAutoPan: true}} 
                        >
                          <div>{value.resourceid}</div>
                        </InfoWindow>
                    </Marker> : ''
          )
          })}
        
        {/* <Polyline path={props.polyPath} defaultZoom={2} editable={false} /> */}
      </GoogleMap>
    );
  });
  /*************** End Of Production Teams Map *************/

  /*************** Create, Update, Delete, NodeStatus, Node Info Production Teams ***************/

  const createconsumerUsersubmit = () => {
    setIsLoading(true);
    let consumerUserData = {
      username: usernameValue,
      firstname: firstNameValue,
      lastname: lastNameValue,
      domain: domainNameValue,
      usertype: userTypeValue,
      phone: phoneNumerValue,
      address: addressValue?.replace(/\n/g, ''),
      city: cityNameValue,
      state: stateNameValue,
      nominee: nomineeValue,
      pancard: pancardValue,
      longitude: longitudeValue,
      latitude: latitudeValue,
      message: messageValue?.replace(/\n/g, ''),
      email: email,
    };
    const consumerUserDataString = JSON.stringify(consumerUserData);
    console.log("consumerUserData:", consumerUserData);
    if (usernameValue && firstNameValue && lastNameValue && phoneNumerValue)
    {
      if (usernameValue === email) {
      MainService.createConsumerUserOfIndividual(consumerUserDataString, username, usernameValue, email)
      .then((res) => {
        setIsLoading(false);
        listOfTeams(getType);
        return NotificationManager.success(res);
      })
      .catch((err) => {
        setIsLoading(false);
        return NotificationManager.error(err);
      });
    } else {
      setIsLoading(false);
      return NotificationManager.error("username and email should be same");
    }
    }else{
      setIsLoading(false);
      return NotificationManager.error("Please fill all required fields");
    }
    
    setConsumerUserDialog(!consumerUserDialog);
  };

  const deleteSubmitClick = () => {
    MainService.deleteConsumerUserIndividual(
      username,
      selectedConsumerUserName,
      selectedConsumerUserId
    )
      .then((res) => {
        listOfTeams(getType);
        return NotificationManager.success(res);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
    setConsumerUserDeleteDialog(!consumerUserDeleteDialog);
  };

  const deleteDialogClick = (consumerUserName, consumerUserId) => {
    setSelectedConsumerUserName(consumerUserName);
    setSelectedConsumerUserId(consumerUserId);

    setConsumerUserDeleteDialog(!consumerUserDeleteDialog);
  };

  const resetPasswordDialogClick = (consumerUserId) => {
    setSelectedConsumerUserId(consumerUserId);
    setconsumerUserResetPasswordDialog(!consumerUserResetPasswordDialog);
  };

  const resetPasswordSubmit = () => {
    if (newPasswordValue === "") {
      return NotificationManager.error("please provide password");
    }
    if (newPasswordValue === passwordConfirmationValue) {
      let resetPwdData = {
        type: "password",
        value:sha256(newPasswordValue),
        temporary: false,
      };
      MainService.resetConsumerUserPasswordIndividual(
        resetPwdData,
        username,
        selectedConsumerUserId
      )
        .then((res) => {
          return NotificationManager.success(res);
        })
        .catch((err) => {
          return NotificationManager.error(err);
        });
      setconsumerUserResetPasswordDialog(!consumerUserResetPasswordDialog);
    } else {
      return NotificationManager.error(
        " Confirmation Password is not match with New password"
      );
    }
  };

  const consumerUserUpdateDialogClick = (consumerUser) => {
    setSelectedConsumerUserName(consumerUser.username);
    setSelectedConsumerUserId(consumerUser.userid);
    
    setConsumerUserUserId(consumerUser.userid);
    setConsumerUserUserName(consumerUser.username);
    setConsumerUserFirstName(consumerUser.firstname);
    setConsumerUserLastName(consumerUser.lastname);
    setConsumerUserEmail(consumerUser.email);
    setConsumerUserPhone(consumerUser.phone);
    setConsumerUserAddress(consumerUser.address);
    setConsumerUserCity(consumerUser.city);
    setConsumerUserState(consumerUser.state);
    setConsumerUserNominee(consumerUser.nominee);
    setConsumerUserPancard(consumerUser.pancard);
    setConsumerUserLongitude(consumerUser.longitude);
    setConsumerUserLatitude(consumerUser.latitude);
    setConsumerUserMessage(consumerUser.message);
    setConsumerUserUserType(consumerUser.usertype);
    setConsumerUserUserDomainName(consumerUser.domain);

    setConsumerUserUpdateDialog(!consumerUserUpdateDialog);
  };

  const consumerUserUpdateSubmit = () => {
    let consumerUserUpdateData = {
      firstname: consumerUserFirstName,
      lastname: consumerUserLastName,
      phone: consumerUserPhone,
      address: consumerUserAddress?.replace(/\n/g, ''),
      city: consumerUserCity,
      state: consumerUserState,
      nominee: consumerUserNominee,
      pancard: consumerUserPancard,
      longitude: consumerUserLongitude,
      latitude: consumerUserLatitude,
      message: consumerUserMessage?.replace(/\n/g, ''),
      email: consumerUserEmail,
    };
    const consumerUserUpdateDataString = JSON.stringify(consumerUserUpdateData);
    MainService.updateConsumerUserInfoIndividual(
      username,
      consumerUserUpdateDataString,
      selectedConsumerUserId,
      selectedConsumerUserName
    )
      .then((res) => {
        return NotificationManager.success(res);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
    setConsumerUserUpdateDialog(!consumerUserUpdateDialog);
  };

  const updateNodeStatusClick = (consumerUserName) => {
    setSelectedNodeNameValue(consumerUserName);
    setConsumerUserUpdateNodeStatusDialog(!consumerUserUpdateNodeStatusDialog);
  };

  const updateNodeStatusSubmit = () => {
    if (nodeStatusValue === "") {
      return NotificationManager.error("please select status");
    }

    MainService.updateConsumerNodeStatus(selectedNodeNameValue, nodeStatusValue)
      .then((res) => {
        return NotificationManager.success(res);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
    setConsumerUserUpdateNodeStatusDialog(!consumerUserUpdateNodeStatusDialog);
  };

  const viewNodeInfoClick = (consumerUserName) => {
    
    MainService.getConsumerNodeInfo(consumerUserName)
      .then((res) => {
        setNodeUserName(res[0].username);
        setNodeUserNodeId(res[0].nodeid);
        setNodeUserAccountType(res[0].accounttype);
        setNodeUserUserType(res[0].usertype);
        setNodeUserAssetType(res[0].assettype);
        setNodeUserNumberOfAssets(res[0].numberofassets);
        setNodeUserAreaSize(res[0].areasize);
        setNodeUserGrazingType(res[0].grazingtype);
        setNodeUserFeedType(res[0].feedtype);
        setNodeUserNumberOfKids(res[0].numberofkids);
        setNodeUserMaleGenderNumber(res[0].malegendernumber);
        setNodeUserFemaleGenderNumber(res[0].femalegendernumber);
        setNodeUserOverallAge(res[0].overallage);
        setNodeUserBreed(res[0].breed);
        setNodeUserFarmingExperience(res[0].farmingexperience);
        setNodeUserNodeStatus(res[0].nodestatus);
        setNodeUserContentUrl(res[0].contenturl);
        setNodeUserNodeType(res[0].nodetype);
        setNodeUserAssetverticalId(res[0].assetverticalid);
        setNodeUserAssetverticalFriendlyName(res[0].assetverticalfriendlyname);
        setNodeUserFirstName(res[0].firstname);
        setNodeUserLastName(res[0].lastname);
        setNodeUserEmail(res[0].email);
        setNodeUserPhone(res[0].phone);
        setNodeUserAddress(res[0].address);
        setNodeUserCity(res[0].city);
        setNodeUserState(res[0].state);
        setNodeUserDistrict(res[0].district);
        setNodeUserPincode(res[0].pincode);
        setNodeUserLatitude(res[0].latitude);
        setNodeUserLongitude(res[0].longitude);
        setNodeUserTimestamp(res[0].timestamp);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
    setConsumerUserViewNodeInfoDialog(!consumerUserViewNodeInfoDialog);
  };
  /*************** End Of Create, Update, Delete, NodeStatus, NodeInfo Production Teams ***************/

  return (
    <React.Fragment>
      <div className="container" id="mainContentList">
        <Fab
            color="primary"
            size={"large"}
            aria-label="add"
            title="Add Production Team"
            className={classes.fab}
            onClick={() => {
              setConsumerUserDialog(!consumerUserDialog);
            }}
          >
            <AddIcon></AddIcon>
        </Fab>
        <div className="topHeadersWrapper">
          <div className="topHeaders">
          <Button
                  startIcon={<ListIcon/>}
                  size="large"
                  onClick={()=>{listOfTeams("List")}}
                />            
            <Button
                  startIcon={<GridIcon/>}
                  size="large"
                  onClick={()=>{listOfTeams("Grid")}}
                >
            </Button>
            <Button
                  startIcon={<MapIcon/>}
                  size="large"
                  onClick={()=>{listOfTeams("Map")}}
                >
            </Button>
          </div>
        </div>

        {setListOpe === true ?
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30 }}>
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
          />
          {setUsers.length > 0 ?
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 500 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow align="center">
                      <TableCell align="center" colSpan={12}>
                        List Of Teams
                      </TableCell>
                    </TableRow>
                    <TableRow align="center">
                      <TableCell align="center" colSpan={1}>
                        User Id
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        User Name
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Email
                      </TableCell>
                      <TableCell align="center" colSpan={4}>
                        View
                      </TableCell>
                      <TableCell align="center" colSpan={4}>
                        Operate
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {setUsers
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((user, index) => {
                          return (
                            <TableRow hover tabIndex={-1} key={index}>
                              <TableCell align="center">
                                {user.userid}
                              </TableCell>
                              <TableCell align="center">
                                {user.username}
                              </TableCell>
                              <TableCell align="center">
                                {user.email}
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  startIcon={<GridIcon/>}
                                  size="large"
                                  onClick={() => {
                                    roleNameOfTeam(user.username,"List");
                                  }}
                                >
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                 startIcon={<GridIcon/>}
                                 size="large"
                                  onClick={() => {
                                    roleNameOfTeam(user.username,"Grid");
                                  }}
                                >
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  startIcon={<MapIcon/>}
                                  size="large"
                                  onClick={() => {
                                    roleNameOfTeam(user.username,"Map");
                                  }}
                                >
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    viewNodeInfoClick(user.username)
                                  }}
                                >
                                  Node Info
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    resetPasswordDialogClick(
                                      user.userid
                                    )
                                  }}
                                >
                                  Reset Password
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    consumerUserUpdateDialogClick(
                                      user
                                    )
                                  }}
                                >
                                  Update
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    deleteDialogClick(
                                      user.username,
                                      user.userid
                                    )
                                  }}
                                >
                                  Delete
                                </Button>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    updateNodeStatusClick(
                                      user.username
                                    )
                                  }}
                                >
                                  Node Status
                                </Button>
                              </TableCell>
                              
                            </TableRow>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={setUsers.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper> : 
            <h4>No Teams Found</h4>
          }
        </Box> : null }

        {setGridOpe === true ? 
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30 }}>
          <SearchBar
            value={farmgridsearched}
            onChange={(searchVal) => requestFarmGridSearch(searchVal)}
            onCancelSearch={() => cancelFarmGridSearch()}
          />
          {isLoading ? (
                    <div className="cardStyleForDashboardItems">
                      <CircularProgress />
                    </div>
                  ) : (
          <div className="cardStyleForDashboardItems">
            <h4 style={{width:"100%",textAlign:"center"}}> List OF TEAMS</h4>
            {setUsers.length > 0 ? (
              <div className="cardStyleForDashboardItems">
                {setUsers.map((ope, index) => (
                  <div
                    key={index}
                    className="cardStyleForDashboardItemsBody"
                  >
                    <span>
                      <p>
                        <b>User Id:</b>
                        {ope.userid}
                      </p>
                      <p>
                        <b>User Name:</b>
                        {ope.username}
                      </p>
                      <p>
                        <b>Email:</b>
                        {ope.email}
                      </p>
                      <div style={{width:"100%",margin:"5px"}}>
                      <h4 className="cardactiontitle">View</h4>
                        <Button
                          startIcon={<GridIcon/>}
                          size="large"
                          onClick={() => {
                            roleNameOfTeam(ope.username,"Grid");
                          }}
                        >
                        </Button>
                        <Button
                          startIcon={<MapIcon/>}
                          size="large"
                          onClick={() => {
                            roleNameOfTeam(ope.username,"Map");
                          }}
                        >
                        </Button>
                        <Button
                          startIcon={<ListIcon/>}
                          size="large"
                          onClick={() => {
                            roleNameOfTeam(ope.username,"List");
                          }}
                        >
                        </Button>
                        <br/>
                        <Button
                        style={{marginRight:"10px"}}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          viewNodeInfoClick(ope.username)
                        }}
                      >
                        Node Info
                      </Button>
                      </div>
                      <div style={{width:"100%",margin:"5px"}}>
                      <h4 className="cardactiontitle">View</h4>
                      <Button
                        style={{marginRight:"10px"}}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          consumerUserUpdateDialogClick(
                            ope
                          )
                        }}
                      >
                        Update
                      </Button>
                      <Button
                        style={{marginRight:"10px"}}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          deleteDialogClick(
                            ope.username,
                            ope.userid
                          )
                        }}
                      >
                        Delete
                      </Button>
                      </div>
                      <div style={{width:"100%",margin:"5px"}}>
                      <Button
                        style={{marginRight:"10px"}}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          updateNodeStatusClick(
                            ope.username
                          )
                        }}
                      >
                        Node Status
                      </Button>
                      <Button
                        style={{marginRight:"10px"}}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          resetPasswordDialogClick(
                            ope.userid
                          )
                        }}
                      >
                        Reset Password
                      </Button>
                      </div>
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <h4>No Teams Found.</h4>
            )}
          </div>
                  )}
        </Box>: null}

        {setMapOpe === true ?
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30 }}>
          {setUsers.length > 0 ?
          <TeamsGoogleMap
            containerElement={ <div style={{ height: `500px`, width: '100%'}} /> }
            mapElement={ <div style={{ height: `100%` }} /> }
          /> : <h4>No Teams Found</h4>}
        </Box> : null }

        {setViewSites === true ?
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30 }}>
        <div className="MuiGrid-root">
          <h2>List Of Sites</h2>
          <div className="cardStyleForDashboardItems">
              <div className="cardStyleForDashboardItems">
              {setResources.length > 0 ?
                <Paper sx={{ width: 1100 }}>
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow align="center">
                          <TableCell align="center" colSpan={1}>
                            Site Id
                          </TableCell>
                          <TableCell align="center" colSpan={1}>
                            Resource Type
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {setResources
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((asset, index) => {
                              console.log("assets",asset);
                              return (
                                <TableRow hover tabIndex={-1} key={index}>
                                  <TableCell align="center">
                                    {asset.resourceid}
                                  </TableCell>
                                  <TableCell align="center" colSpan={1}>
                                    {asset.resourcetype}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={setResources.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper> : 
                <h4>No Sites List Found</h4>
              }
              </div>
          </div>
        </div>
        </Box> : null }

        {setGridSites === true ? 
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30}}>
          <div className="cardStyleForDashboardItems">
           <p style={{width:"100%",textAlign:"center"}}><h3>List OF SITES</h3></p>
            {setResources.length > 0 ? (
              <div className="cardStyleForDashboardItems">
                {setResources.map((site, index) => (
                  <div
                    key={index}
                    className="cardStyleForDashboardItemsBody"
                  >
                    <span>
                      <p>
                        <b>Site Id:</b>
                        {site.resourceid}
                      </p>
                      <p>
                        <b>Resource Type:</b>
                        {site.resourcetype}
                      </p>
                     
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <h4>No Sites Found.</h4>
            )}
          </div>
        </Box>: null}

        {setMapSites === true ?
        <Box sx={{ width: "100%", marginBottom: 30, marginTop:30}}>
          {setResources.length > 0 ?
          <SitesGoogleMap
            containerElement={ <div style={{ height: `500px`, width: '100%'}} /> }
            mapElement={ <div style={{ height: `100%` }} /> }
          /> 
          : <h4>No Sites Found</h4>}
        </Box> : null }

        {/* create Consumer User Production Teams */}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserDialog}
          // onClose={handleClose}
          aria-labelledby="craete Consumer User"
        >
          <DialogTitle id="createConsumerUser">
            {"Create Production Teams"}
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="username">Consumer User Name :</InputLabel>
              <Input
                id="username"
                name="username"
                type="email"
                value={usernameValue}
                onChange={(e) => {
                  setUsernameValue(e.target.value);
                }}
              />
            </FormControl>

            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="firstName">First Name :</InputLabel>
              <Input
                id="firstName"
                name="firstName"
                type="text"
                value={firstNameValue}
                onChange={(e) => {
                  setFirstNameValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="lastName">Last Name :</InputLabel>
              <Input
                id="lastName"
                name="lastName"
                type="text"
                value={lastNameValue}
                onChange={(e) => {
                  setLastNameValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="domainName">Domain Name :</InputLabel>
              <Input
                id="domainName"
                name="domainName"
                type="text"
                value={domainNameValue}
                onChange={(e) => {
                  setDomainNameValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="userType">User Type</InputLabel>
              <Select
                id="userType"
                name="userType"
                value={userTypeValue}
                onChange={(e) => {
                  setUserTypeValue(e.target.value);
                }}
              >
                {/* <MenuItem selected value="Executive">
                  Executive
                </MenuItem> */}
                {/* <MenuItem value="ProductionManager">
                  Production-Manager
                </MenuItem> */}
                <MenuItem value="Production-Team">Production-Team</MenuItem>
                {/* <MenuItem value="Operator">Operator</MenuItem> */}
                {/* <MenuItem value="DeveloperQA">DeveloperQA</MenuItem> */}
                {/* <MenuItem value="Agent">Agent</MenuItem> */}
                {/* <MenuItem value="Farmer">Farmer</MenuItem> */}
              </Select>
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="email">E-Mail Id:</InputLabel>
              <Input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="mobileNumber">Mobile Number :</InputLabel>
              <Input
                id="mobileNumber"
                name="mobileNumber"
                type="text"
                value={phoneNumerValue}
                onChange={(e) => {
                  setPhoneNumerValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="address">Address:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={addressValue}
                onChange={(e) => {
                  setAddressValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="city">City :</InputLabel>
              <Input
                id="city"
                name="city"
                type="text"
                value={cityNameValue}
                onChange={(e) => {
                  setCityNameValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="state">State :</InputLabel>
              <Input
                id="state"
                name="state"
                type="text"
                value={stateNameValue}
                onChange={(e) => {
                  setStateNameValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="nominee">Nominee :</InputLabel>
              <Input
                id="nominee"
                name="nominee"
                type="text"
                value={nomineeValue}
                onChange={(e) => {
                  setNomineeValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="pancard">Pancard Number :</InputLabel>
              <Input
                id="pancard"
                name="pancard"
                type="text"
                value={pancardValue}
                onChange={(e) => {
                  setPancardValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="longitude">Longitude :</InputLabel>
              <Input
                id="longitude"
                name="longitude"
                type="text"
                value={longitudeValue}
                onChange={(e) => {
                  setLongitudeValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="latitude">Latitude :</InputLabel>
              <Input
                id="latitude"
                name="latitude"
                type="text"
                value={latitudeValue}
                onChange={(e) => {
                  setLatitudeValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="messageDescription">Message:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={messageValue}
                onChange={(e) => {
                  setMessageValue(e.target.value);
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                createconsumerUsersubmit();
              }}
            >
              Submit
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setIsLoading(false);
                setConsumerUserDialog(!consumerUserDialog);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Of Create Consumer User Production Teams */}
        {/* Delete Production Teams */}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserDeleteDialog}
          // onClose={handleClose}
          aria-labelledby="deleteConsumerUser"
        >
          <DialogTitle id="deleteConsumerUser">
            {"Delete Production Teams User"}
          </DialogTitle>
          <DialogContent>
            <h4>Are you sure want to delete?</h4>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                deleteSubmitClick();
              }}
            >
              Submit
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setConsumerUserDeleteDialog(!consumerUserDeleteDialog);
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Of Delete Production Teams */}
        {/* Reset Password Of Production Teams */}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserResetPasswordDialog}
          // onClose={handleClose}
          aria-labelledby="consumerUserResetPassword"
        >
          <DialogTitle id="consumerUserResetPassword">
            Production Teams Password Reset
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="newPassword">New Password:</InputLabel>
              <Input
                id="newPassword"
                name="newPassword"
                type="text"
                value={newPasswordValue}
                onChange={(e) => {
                  setNewPasswordValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="passwordConfirmation">
                Password Confirmation:
              </InputLabel>
              <Input
                id="passwordConfirmation"
                name="passwordConfirmation"
                type="text"
                value={passwordConfirmationValue}
                onChange={(e) => {
                  setPasswordConfirmationValue(e.target.value);
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                resetPasswordSubmit();
              }}
            >
              Submit
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setconsumerUserResetPasswordDialog(
                  !consumerUserResetPasswordDialog
                );
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Of Reset Password Production Teams */}
        {/* Update Production Teams*/}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserUpdateDialog}
          // onClose={handleClose}
          aria-labelledby="UpdateConsumerUser"
        >
          <DialogTitle id="UpdateConsumerUser">
            {"Update Production Teams"}
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="username">Consumer User Name :</InputLabel>
              <Input
                disabled
                id="username"
                name="username"
                type="email"
                value={consumerUserUserName}
              />
            </FormControl>

            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="firstName">First Name :</InputLabel>
              <Input
                id="firstName"
                name="firstName"
                type="text"
                value={consumerUserFirstName}
                onChange={(e) => {
                  setConsumerUserFirstName(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="lastName">Last Name :</InputLabel>
              <Input
                id="lastName"
                name="lastName"
                type="text"
                value={consumerUserLastName}
                onChange={(e) => {
                  setConsumerUserLastName(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="domainName">Domain Name :</InputLabel>
              <Input
                disabled
                id="domainName"
                name="domainName"
                type="text"
                value={consumerUserUserDomainName}
                onChange={(e) => {
                  setConsumerUserUserDomainName(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="userType">User Type</InputLabel>
              <Select
                disabled
                id="userType"
                name="userType"
                value={consumerUserUserType}
              ></Select>
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="email">E-Mail Id:</InputLabel>
              <Input
                id="email"
                name="email"
                type="email"
                value={consumerUserEmail}
                onChange={(e) => {
                  setConsumerUserEmail(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="mobileNumber">Mobile Number :</InputLabel>
              <Input
                id="mobileNumber"
                name="mobileNumber"
                type="text"
                value={consumerUserPhone}
                onChange={(e) => {
                  setConsumerUserPhone(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="address">Address:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={consumerUserAddress}
                onChange={(e) => {
                  setConsumerUserAddress(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="city">City :</InputLabel>
              <Input
                id="city"
                name="city"
                type="text"
                value={consumerUserCity}
                onChange={(e) => {
                  setConsumerUserCity(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="state">State :</InputLabel>
              <Input
                id="state"
                name="state"
                type="text"
                value={consumerUserState}
                onChange={(e) => {
                  setConsumerUserState(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="nominee">Nominee :</InputLabel>
              <Input
                id="nominee"
                name="nominee"
                type="text"
                value={consumerUserNominee}
                onChange={(e) => {
                  setConsumerUserNominee(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="pancard">Pancard Number :</InputLabel>
              <Input
                id="pancard"
                name="pancard"
                type="text"
                value={consumerUserPancard}
                onChange={(e) => {
                  setConsumerUserPancard(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="longitude">Longitude :</InputLabel>
              <Input
                id="longitude"
                name="longitude"
                type="text"
                value={consumerUserLongitude}
                onChange={(e) => {
                  setConsumerUserLongitude(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="latitude">Latitude :</InputLabel>
              <Input
                id="latitude"
                name="latitude"
                type="text"
                value={consumerUserLatitude}
                onChange={(e) => {
                  setConsumerUserLatitude(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="messageDescription">Message:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={consumerUserMessage}
                onChange={(e) => {
                  setConsumerUserMessage(e.target.value);
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                consumerUserUpdateSubmit();
              }}
            >
              Submit
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setConsumerUserUpdateDialog(!consumerUserUpdateDialog);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Of Update Production Teams*/}
        {/* Node Status Update*/}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserUpdateNodeStatusDialog}
          // onClose={handleClose}
          aria-labelledby="consumerUserNodeUpdate"
        >
          <DialogTitle id="consumerUserNodeUpdate">
            Update Node Status
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="nodeName">Node Name :</InputLabel>
              <Input
                disabled
                id="nodeName"
                name="nodeName"
                type="text"
                value={selectedNodeNameValue}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="nodeStatus">Update Node Status</InputLabel>
              <Select
                id="nodeStatus"
                name="nodeStatus"
                value={nodeStatusValue}
                onChange={(e) => {
                  setNodeStatusValue(e.target.value);
                }}
              >
                <MenuItem value="AssetOEM">Authentication Pending</MenuItem>
                <MenuItem value="AssetSeller">Authenticated</MenuItem>
                <MenuItem value="AssetDeveloper">Approved</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                updateNodeStatusSubmit();
              }}
            >
              Update
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setConsumerUserUpdateNodeStatusDialog(
                  !consumerUserUpdateNodeStatusDialog
                );
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Of Node Status Update*/}
        {/*Node Info */}
        <Dialog
          fullScreen={fullScreen}
          open={consumerUserViewNodeInfoDialog}
          // onClose={handleClose}
          aria-labelledby="consumerUserNodeInfo"
        >
          <DialogTitle id="consumerUserNodeInfo">View Node Info</DialogTitle>
          <DialogContent>
            <p>
              <b>User Name : </b>
              {nodeUserName}
            </p>
            <p>
              <b>Node ID : </b>
              {nodeUserNodeId}
            </p>
            <p>
              <b>Account Type : </b>
              {nodeUserAccountType}
            </p>
            <p>
              <b>User Type : </b>
              {nodeUserUserType}
            </p>
            <p>
              <b>Asset Type : </b>
              {nodeUserAssetType}
            </p>
            <p>
              <b>Number Of Assets : </b>
              {nodeUserNumberOfAssets}
            </p>
            <p>
              <b>Area Size : </b>
              {nodeUserAreaSize}
            </p>
            <p>
              <b>Grazing Type : </b>
              {nodeUserGrazingType}
            </p>
            <p>
              <b>Feed Type : </b>
              {nodeUserFeedType}
            </p>
            <p>
              <b>Number Of Kids : </b>
              {nodeUserNumberOfKids}
            </p>
            <p>
              <b>Male Gender Number : </b>
              {nodeUserMaleGenderNumber}
            </p>
            <p>
              <b>Female Gender Number : </b>
              {nodeUserFemaleGenderNumber}
            </p>
            <p>
              <b>Over All Age : </b>
              {nodeUserOverallAge}
            </p>
            <p>
              <b>Breed : </b>
              {nodeUserBreed}
            </p>
            <p>
              <b>Farming Experience : </b>
              {nodeUserFarmingExperience}
            </p>
            <p>
              <b>Node Status : </b>
              {nodeUserNodeStatus}
            </p>
            <p>
              <b>Content Url : </b>
              {nodeUserContentUrl}
            </p>
            <p>
              <b>Node Type : </b>
              {nodeUserNodeType}
            </p>
            <p>
              <b>Assetvertical Id : </b>
              {nodeUserAssetverticalId}
            </p>
            <p>
              <b>Assetvertical Friendly Name: </b>
              {nodeUserAssetverticalFriendlyName}
            </p>
            <p>
              <b>Firstname : </b>
              {nodeUserFirstName}
            </p>
            <p>
              <b>Last Name : </b>
              {nodeUserLastName}
            </p>
            <p>
              <b>Email : </b>
              {nodeUserEmail}
            </p>
            <p>
              <b>Phone : </b>
              {nodeUserPhone}
            </p>
            <p>
              <b>State : </b>
              {nodeUserState}
            </p>
            <p>
              <b>City : </b>
              {nodeUserCity}
            </p>
            <p>
              <b>District : </b>
              {nodeUserDistrict}
            </p>
            <p>
              <b>Pincode : </b>
              {nodeUserPincode}
            </p>
            <p>
              <b>Latitude : </b>
              {nodeUserLatitude}
            </p>
            <p>
              <b>Longitude : </b>
              {nodeUserLongitude}
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setConsumerUserViewNodeInfoDialog(
                  !consumerUserViewNodeInfoDialog
                );
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/*End Of Node Info */}

      </div>
    </React.Fragment>
  );
}

